/**
 * common function to open whatsapp for messaging the store owner
 * display/registered number
 * @param {Object} - userData, phoneNumber, storeUrl
 */
export const whatsappMessageRender = ({ phoneNumber, storeUrl }) => {
  window.location.href = `whatsapp://send?phone=+91${phoneNumber}&text=Hi%2C%0D%0A%0D%0AI+am+at+your+online+store+and+need+some+help.%0D%0A%0D%0A${storeUrl}`;
};
